import React from 'react';
import { useHistory } from 'react-router-dom';
import { Modal } from '@carvana/showroom-modal';
import DocFinanceIcon from '../../../../../assets/DocFinanceIcon';
import { useDualEventTracking } from '../../../../../utils/useDualEventTracking';
import {
  Body,
  Heading,
  PayCurrentAmountButton,
  PayCurrentAmountPromptWrapper,
} from './PayCurrentAmountPrompt.styles';

const PayCurrentAmountPrompt = (props: {
  vehicleId: any;
  toggleModal: any;
  openModal: any;
  promptOpenTrackEvent: string;
  promptCloseTrackEvent: string;
}) => {
  const {
    vehicleId,
    toggleModal,
    openModal,
    promptOpenTrackEvent,
    promptCloseTrackEvent,
  } = props;

  const { trackEvent } = useDualEventTracking();

  const history = useHistory();

  const heading =
    'To set up autopay for your bridgecrest account, please pay your current amount due.';
  const body =
    'You have a current payment that is either due in less than 5 days or overdue. Please submit a one time payment first.';
  const btnLabel = 'pay current amount due';
  const headerText = 'Autopay';

  const onClosePrompt = () => {
    trackEvent(promptCloseTrackEvent);
    toggleModal();
  };

  const onPayCurrentAmountBtnClick = () => {
    trackEvent('auto_pay_requires_one_time_payment_dialogue_make_payment_tap');
    history.push(`/loan-detail/make-payment/${vehicleId}`);
  };

  const modalContent = (
    <PayCurrentAmountPromptWrapper>
      <DocFinanceIcon />
      <Heading>{heading}</Heading>
      <Body>{body}</Body>
      <PayCurrentAmountButton onClick={onPayCurrentAmountBtnClick}>
        {btnLabel}
      </PayCurrentAmountButton>
    </PayCurrentAmountPromptWrapper>
  );

  return (
    <>
      {openModal && trackEvent(promptOpenTrackEvent)}
      <Modal
        headerText={headerText}
        mode="light"
        isOpen={openModal}
        closeModal={onClosePrompt}
      >
        {modalContent}
      </Modal>
    </>
  );
};

export default PayCurrentAmountPrompt;
